import { errorCodeMap } from '../constants'
import type { I18TranslationKey } from '../types'

export const zhCN: Record<I18TranslationKey, string> = {
    // 登录注册页面文本
    bindMobile: '绑定手机号',
    bindEmail: '绑定邮箱',
    firstLoginNeedAccount: '首次微信登录需绑定{{account}}',
    mobileCode: '手机号',
    noVerificationCodeReceived: '没有收到验证码？',
    noNeedLogin: '暂不支持登录',
    registerAccount: '注册账号',
    mobileLogin: '手机号登录',
    emailLogin: '邮箱登录',
    wechatLogin: '快捷登录',
    emailUrl: '邮箱地址',
    noAccount: '还没有账号？',
    next: '下一步',
    goLogin: '去登录',
    alreadyHaveAnAccount: '已有账号？',
    selectRegisterWay: '选择注册方式',
    perfectInfo: '完善信息',
    verificationCode: '验证码',
    sure: '确定',
    yourRole: '您的角色',
    emailFormatIsIllegal: '邮箱格式不合法',
    mobilePhoneNumberFormatIsIllegal: '手机号格式不合法',
    mobileRegister: '手机号注册',
    emailRegister: '邮箱注册',
    email: '邮箱',
    shortMessage: '短信',
    pleaseInputYourEmail: '请输入邮箱',
    pleaseInputYourMobile: '请输入手机号',
    pleaseInputYourValidEmail: '请输入正确的邮箱',
    pleaseInputYourValidMobile: '请输入正确的手机号',
    getVerificationCode: '获取验证码',
    getAgain: '再次获取',
    register: '注册',
    notEmpty: '不能为空',
    pleaseFillOut: '请填写',
    loginSuccess: '登录成功',
    authSuccess: '授权成功',
    wechatBindSuccess: '微信绑定成功',
    pleaseWeChatLoginInWeChatBrowser: '请在微信浏览器中使用微信登录',
    refresh: '刷新',
    expiredPleaseRefresh: '已过期，刷新',
    scanWechatLogin: '使用微信扫码关注公众号即可登录',
    accountSetting: '账号设置',
    needPublish: '请先将应用发布',
    // 动态文本
    resendTime: `{{v}} s后重发`,
    verificationMessage: `我们已向 {{v}} 发送了验证码，请查看您的邮箱`,
    verificationSMS: `我们已向 {{v}} 发送了短信验证码`,
    inputVerificationCode: `输入{{v}}验证码`,
    confirmMergeAccounts: `确认合并账号？`,
    merge: '合并',
    mergeAccount: '合并账号',
    iAwareRisks: '我已知晓风险',
    cancel: '取消',
    backLoginPage: '返回登录页',
    youAccountUnderReview: '你的账号正在审核',
    keepMobileAndDeleteWechat: '保留手机号的账号 删除微信的账号',
    keepWechatAndDeleteMobile: ' 保留微信的账号 删除手机号的账号',
    MergeWeChatAccountDescription: '将微信和手机号注册的账号合并为一个账号请选择保留的账号：',
    changeBindMobile: '换绑手机号',
    deleteWechatAccountWarn: '此操作将删除微信的账号，且不可恢复，请谨慎操作！',
    mobileAlreadyRegister: '手机号已经注册',
    search: '搜索',
    personNameOrPersonId: '人员名称、人员编号',
    noFindData: '未找到数据',
    noFindPerson: '没有找到人员',
    selected: '只看已选',
    goHome: '回到主页',
    mobileAlreadyRegisterDesc: '该手机号已被注册为：{{name}} ({{userId}})，若仍想绑定该手机号，请点击「合并账号」。',
    logout: '退出登录',
    notBind: '无法解绑',
    mobileNumber: '手机号',
    wechat: '微信',
    removeBindAccountDescribe: '{{account}} 作为本账号唯一登录方式，请先绑定其他账号作为替代登录方式。',
    knew: '知道了',
    continueUnbinding: '继续解绑',
    emailAccount: '邮箱账号',
    alreadyBind: '已绑定',
    wechatAccount: '微信账号',
    notEnabledAccountLogin: '未启用{{account}}登录功能',
    bindAfterUsedAccountLogin: '绑定后可使用{{account}}登录',
    bindAccountAfterAccountNotEnable: '该{{account}}已经注册过账号，请复制微信OpenID后联系并发送给管理员，或者换绑{{account}}。',
    bindMeetQuestion: '绑定遇到问题',
    changeAccount: '更换{{account}}',
    goBind: '去绑定',
    unbind: '解绑',
    notEnable: '未启用',
    bindMobileNumber: '绑定手机号',
    bindMobileNumberAfterLoginApp: '绑定后可使用手机号登录应用',
    enterSmsCode: '输入短信验证码',
    confirmUnbinding: '确认解绑',
    unBindNotLoginConfirmDescribe: '解绑后无法再通过{{account}}途经登录，确认继续解绑？',
    alreadyUnbindAccount: '已解除{{account}}绑定',
    clickToUpload: '点击上传',
    clickOrDragToUpload: '点击或拖入文件',
    uploadFailedMaxFiles: '上传失败，最多上传 {{count}} 个文件',
    rename: '重命名',
    delete: '删除',
    download: '下载',
    view: '查看',
    recordVideo: '录像',
    photograph: '拍照',
    selectFromGallery: '从手机相册选择',
    localFiles: '本地文件',
    more: '更多',
    onlyPicture: '仅支持图片',
    fileTypeNotSupported: '文件类型不支持',
    fileExceedsUploadAvatarLimit: '不能上传大于 {{v}}mb 的头像',
    fileExceedsUploadLimit: '不能上传大于 {{v}}mb 的文件',
    unsupportedFormatOnlyImageUploads: '格式错误，仅支持上传图片',
    unsupportedVideoFormatPleaseUploadMP4file: '视频格式错误，请上传 MP4 格式的视频',
    sort: '排序',
    sortEmptyDescribe: '添加排序规则，让你的数据井然有序',
    sortRule: '排序规则',
    add: '添加',
    group: '分组',
    linesTotal: '共{{ count }}行',
    field: '字段',
    groupBy: '分组依据',
    pleasesSelect: '请选择',
    xItemsSelected: '已选择{{count}}项',
    print: '打印',
    edit: '编辑',
    kanbanSetting: '看板设置',
    foldingBoard: '折叠看板',
    hideBoard: '隐藏看板',
    text: '正文',
    firstLevelHeading: '一级标题',
    secondLevelHeading: '二级标题',
    thirdLevelHeading: '三级标题',
    todoList: '待办列表',
    numberList: '有序列表',
    bulletedList: '无序列表',
    alignCenter: '居中',
    alignLeft: '居左',
    alignRight: '居右',
    clearFormat: '清除格式',
    bold: '加粗',
    strikethrough: '删除线',
    italic: '斜体',
    underline: '下划线',
    textColor: '文本颜色',
    textBackgroundColor: '文本背景色',
    hyperlink: '超级链接',
    insertCode: '插入代码',
    uploadImage: '上传图片',
    insertVideo: '插入视频',
    videoLink: '视频链接',
    localUpload: '本地上传',
    pasteVideoLink: '粘贴视频链接',
    insertCitation: '插入引用',
    divider: '分割线',
    insertTable: '插入表格',
    insertRow: '插入行',
    insertColumn: '插入列',
    insertRowAbove: '向上插入行',
    insertRowBelow: '向下插入行',
    insertColumnLeft: '向左插入列',
    insertColumnRight: '向右插入列',
    deleteRow: '删除行',
    deleteColumn: '删除列',
    deleteTable: '删除表格',
    mergeCells: '合并单元格',
    splitCell: '拆分单元格',
    toggleHeaderRow: '切换表头行',
    toggleHeaderColumn: '切换表头列',
    operation: '操作',
    addOneRow: '添加一行',
    accordingTo: '按',
    pasteLink: '粘贴链接',
    displayedField: '显示字段',
    unDisplayedField: '未显示字段',
    hideAll: '全部隐藏',
    showAll: '全部显示',
    hideEmptyGroups: '隐藏空的分组',
    noData: '暂无数据',
    pleasesGoDataSourceAdd: '请前往数据源添加',
    export: '导出',
    sureDelete: '确认删除？',
    deleteRecordWaring: '删除选中的{{count}}条记录后无法恢复，请谨慎操作',
    undo: '撤销',
    redo: '重做',
    uploadXLSXtips: '点击或拖拽<bold />到此区域',
    uploadingXLSXemptyTips: '请确保：文件中不存在<bold />',
    uploadFileSizeLimitHowMuch: '文件大小不能超过{{v}}MB',
    importLimitNumberW: '每次导入不能超过{{v}}万行数据',
    onlyXLSXorCSVofFile: '仅支持.xlsx、.csv 格式的文件',
    fileNoEmptySheet: '文件中不能有空 Sheet',
    tableFileNoMergeCell: '文件中不能存有合并的单元格',
    localImport: '本地导入',
    exportingOfProgress: '正在导出，请勿重复点击',
    xlsxCsvFileNumber: '.xlsx、.csv文件（{{v}}M以内）',
    emptySheetOrMergeCell: '空工作表和合并单元格',
    batchImport: '批量导入',
    collapseKanban: '折叠看板',
    hideKanban: '隐藏看板',
    groupSetting: '分组设置',
    startImport: '开始导入',
    againImport: '重新导入',
    previous: '上一步',
    createNewTable: '创建新的表',
    appendImportTable: '追加导入到已有表',
    pleasesSelectSheet: '请在 <name /> 中选择 <number /> Sheet',
    a: '一个',
    reupload: '重新上传',
    fieldMapping: '字段映射',
    ofColumn: '的列',
    ofField: '的字段',
    mapping: '映射',
    importSuccess: '导入成功',
    pleasesSetKanbanGrouping: '请设置看板分组依据',

    exportSettings: '导出设置',
    selectRecords: '选择记录',
    exportAllRecords: '导出所有记录',
    exportSpecifiedRecords: '导出指定记录',
    exporting: '正在导出',
    aMaximumOfRecordsCanExportedAtATime: '单次最多导出 {{count}} 条记录',
    printTemplate: '打印模板',
    selectTemplate: '选择模板',
    exportMethod: '导出方式',
    exportByPage: '分页导出（所有数据合成一个pdf文件，且数据分页）',
    noExportTemplate: '暂无导出模板',
    exportingPDFforPrinting: '正在导出用于打印的PDF文件',
    exportFailedTheExportFileCannotExceedNumber: '导出失败，导出的文件大小不能超过 {{size}}mb',
    exportFailedOfNumberRecordsExport: '导出失败，每次最多导出 {{count}} 条记录',
    // date
    beforeYesterday: '前天',
    yesterday: '昨天',
    today: '今天',
    tomorrow: '明天',
    afterTomorrow: '后天',
    // 筛选器
    custom: '自定义',
    clear: '清除',
    thisWeek: '本周',
    lastWeek: '上周',
    nextWeek: '下周',
    thisMonth: '本月',
    lastMonth: '上月',
    nextMonth: '下月',
    thisYear: '今年',
    lastYear: '去年',
    thisQuarter: '本季度',
    nextQuarter: '下季度',
    pastFourteenDays: '过去14天',
    nextFourteenDays: '未来14天',
    pastThirtyDays: '过去30天',
    nextThirtyDays: '未来30天',
    nextSevenDays: '未来7天',
    pastSevenDays: '过去7天',
    yes: '是',
    no: '否',
    complete: '完成',
    pleasesAddFilter: '请添加筛选项',
    messageNotification: '消息通知',
    from: '来自',
    all: '全部',
    startTime: '开始时间',
    endTime: '结束时间',
    min: '最小值',
    max: '最大值',
    userNotExist: '不存在的用户',
    now: '此刻',
    lastQuarter: '上季度',
    afterSomeWhatDays: '多少天后',
    beforeSomeWhatDays: '多少天前',
    nextYear: '明年',
    optionNotFound: '找不到选项',
    componentNotFound: '找不到该组件',
    generatingImage: '正在生成图片',
    imageGeneratedSuccessfully: '图片生成成功',
    imageUploadMaxLimitSizeWithKb: '不能上传超过 {{size}}KB 的图片',
    // 动作
    configurationNotPerfect: '配置未完善',
    useMiniProgram: '请在微信小程序环境中使用',
    createRecordError: '创建记录异常',
    sendAliyunMsgError: '发送阿里云短信异常',
    deleteRecordError: '删除记录异常',
    getRecordError: '获取记录异常',
    updateRecordError: '更新记录异常',
    datasourceNotFound: '未找到对应的数据源',
    subProcessNotFound: '未找到对应的子流程',
    handleSubProcessError: '执行子流程异常',
    openPageError: '打开页面失败',
    cannotStripe: '不能在搭建端使用stripe支付，请在发布后或预览版中使用。',
    cannotWechatOpenLocation: '不能在搭建端使用微信打开位置，请在发布后或预览版中使用。',
    cannotWechatOpenAudioPlayer: '不能在搭建端使用小程序打开音频播放器，请在发布后或预览版中使用。',
    cannotMiniProgramSubscribeMsg: '不能在搭建端使用小程序订阅消息，请在发布后或预览版中使用。',
    cannotMiniProgramNavigateToMiniProgram: '不能在搭建端使用小程序跳转小程序，请在发布后或预览版中使用。',
    cannotMiniProgramOpenChannelsActivity: '不能在搭建端使用小程序打开视频号视频，请在发布后或预览版中使用。',
    cannotOpenWechatCustomerService: '不能在搭建端使用打开微信客服，请在发布后或预览版中使用。',
    cannotWechatPay: '不能在搭建端使用微信支付，请在发布后或预览版中使用。',
    cannotUpdatePageShare: '不能在搭建端使用更新分享信息，请在发布后或预览版中使用。',
    sendWxTemplateMsgError: '微信模版消息发送失败',
    useMiniProgramEnv: '请在微信小程序环境中使用“小程序授权订阅消息”的功能',

    cannotStripeInWx: '微信小程序中不能使用Stripe支付',
    stripeNeedLogin: 'Stripe支付需要登录',
    upstreamNodeConfigurationNotPerfect: '上游节点配置未完善',
    getStripeRecordError: '获取Stripe支付订单异常',
    dataUpdateSuccess: '数据更新成功',
    pageIdError: '页面id异常',
    wechatPayNeedLogin: '微信支付需要登录',
    getWechatPayRecordError: '获取微信支付订单异常',
    wechatPayInWechatEnv: '请在微信环境发起支付',
    wechatMiniProgramLocationEnv: '请在微信小程序环境中使用导航功能',
    wechatMiniProgramAudioPlayerEnv: '请在微信小程序环境中使用音频播放器功能',
    multipleFileDownloadNotSupported: '不支持同时下载多个文件',
    downloadInProgress: '正在下载...',
    copySuccess: '复制成功',
    // toast
    ...errorCodeMap
}
